import { render, staticRenderFns } from "./FiveStarIcons.vue?vue&type=template&id=6cf01a65&scoped=true&"
import script from "./FiveStarIcons.vue?vue&type=script&lang=js&"
export * from "./FiveStarIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf01a65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
